import { jsxs, jsx } from "react/jsx-runtime";
import { Table, Anchor, Icon } from "@zillow/constellation-10";
import { IconArrowUpFilled, IconArrowDownFilled } from "@zillow/constellation-icons";
import "react";
const MortgageRateItem = ({
  rate,
  columns
}) => {
  var _a;
  return /* @__PURE__ */ jsxs(Table.Row, { children: [
    /* @__PURE__ */ jsx(Table.Cell, { align: "left", children: ((_a = rate == null ? void 0 : rate.link) == null ? void 0 : _a.url) ? /* @__PURE__ */ jsx(Anchor, { href: rate.link.url, target: rate.link.opensInNewTab ? "_blank" : void 0, rel: rate.link.opensInNewTab ? "noopener noreferrer" : void 0, children: rate.program }) : rate.program }),
    columns.includes("rate") && /* @__PURE__ */ jsxs(Table.Cell, { align: "right", children: [
      rate.rate,
      "%"
    ] }),
    columns.includes("rateChange") && /* @__PURE__ */ jsxs(Table.Cell, { align: "right", children: [
      /* @__PURE__ */ jsx(Icon, { css: {
        color: rate.isRateChangeUp ? "text.accent.red.hero" : "text.accent.green.hero",
        marginRight: "tighter",
        verticalAlign: "middle"
      }, children: rate.isRateChangeUp ? /* @__PURE__ */ jsx(IconArrowUpFilled, {}) : /* @__PURE__ */ jsx(IconArrowDownFilled, {}) }),
      rate.rateChange,
      "%"
    ] }),
    columns.includes("apr") && /* @__PURE__ */ jsxs(Table.Cell, { align: "right", children: [
      rate.apr,
      "%"
    ] }),
    columns.includes("aprChange") && /* @__PURE__ */ jsxs(Table.Cell, { align: "right", children: [
      /* @__PURE__ */ jsx(Icon, { css: {
        color: rate.isAprChangeUp ? "text.accent.red.hero" : "text.accent.green.hero",
        marginRight: "tighter",
        verticalAlign: "middle"
      }, children: rate.isAprChangeUp ? /* @__PURE__ */ jsx(IconArrowUpFilled, {}) : /* @__PURE__ */ jsx(IconArrowDownFilled, {}) }),
      rate.aprChange,
      "%"
    ] })
  ] });
};
export {
  MortgageRateItem as default
};
